import React from "react";
import { useCheckout } from "../../../hooks/useCheckout";

export function CheckOut() {
  const checkout = useCheckout();

  return (
    <button
      className="new-green-btn"
      onClick={checkout.initiate}
      disabled={checkout.isLoading}
    >
      {checkout.isLoading ? "Unchecking..." : "Uncheck Appointment"}
    </button>
  );
}
